import AuthLayout from "@/components/AuthLayout"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

interface Props {
  token: string
  alert: string | null
  notice: string | null
}

function getCsrfToken() {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
}

export default function SetupPasswordPage({ token, alert, notice }: Props) {
  return (
    <AuthLayout
      title="Configurar contraseña"
      subtitle="Se ha creado una cuenta para ti. Para comenzar, crea tu contraseña."
      alert={alert}
      notice={notice}
    >
      <form method="post" action={`/password_setups/${token}`} className="flex flex-col gap-6">
        <input type="hidden" name="authenticity_token" value={getCsrfToken()} />
        <input type="hidden" name="_method" value="patch" />

        <div className="flex flex-col gap-3">
          <Label htmlFor="password">Contraseña</Label>
          <Input
            id="password"
            name="password"
            type="password"
            autoComplete="new-password"
            autoFocus
            required
            maxLength={72}
            placeholder="••••••••"
          />
        </div>

        <div className="flex flex-col gap-3">
          <Label htmlFor="password_confirmation">Confirmar contraseña</Label>
          <Input
            id="password_confirmation"
            name="password_confirmation"
            type="password"
            autoComplete="new-password"
            required
            maxLength={72}
            placeholder="••••••••"
          />
        </div>

        <Button type="submit" className="w-full">
          Configurar contraseña
        </Button>
      </form>
    </AuthLayout>
  )
}
